export default __webpack_public_path__ + "static/media/Lily_Icon.a0ca328b.png";